<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <caracteristique :produit="produit" :sousProduit="sousProduit"></caracteristique>
    </div>
    <div class="column is-6 mgt-20px">
      <dates :produit="sousProduit"></dates>
    </div>
    <div v-if="modulePresseActive && isProduitTypePresse" class="column is-6 mgt-20px">
      <format-produit-presse :produit="sousProduit"></format-produit-presse>
    </div>
    <div class="column is-6 mgt-20px">
      <div class="card height-100">
        <header class="header-card">
          <p>
            {{$t('produitSalon.comptabilite.title')}}
          </p>
        </header>
        <div class="card-content columns">
          <schema-comptable
            :objetAvecSchemaComptable="produit"
            :isConsultation="false"
            class="column is-8">
          </schema-comptable>
          <select-compte-analytique
            :produit="produit"
            :disabled="!!produit.regroupementProduitId"
            class="column is-4">
          </select-compte-analytique>
        </div>
      </div>
    </div>
    <div class="column is-6 mgt-20px" v-if="modulePresseActive">
      <div class="card">
        <header class="header-card">
          <p>{{ $t('produitSalon.marche.title') }}</p>
        </header>
        <div class="card-content">
          <marche
            :produit="produit"
            :societeId="produitSociete"
            :disabled="!!produit.regroupementProduitId"
            class="mgb-10px">
          </marche>
          <regle-facturation
            :produit="produit"
            :disabled="!!produit.regroupementProduitId">
          </regle-facturation>
        </div>
      </div>
    </div>
    <div class="column is-6 mgt-20px">
      <div class="card ">
        <header class="header-card">
          <p>{{ $t('produitSalon.commentaire.title') }}</p>
        </header>
        <div class="card-content">
          <b-field :label="$t('produitSalon.commentaire.field')">
            <b-input v-model="produit.commentaire" type="textarea">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <produit-commentaire-vente-card
      :produit="produit"
      class="column is-6 mgt-20px"/>
    <div v-if="modulePresseActive && isProduitTypePresse" class="column is-6 mgt-20px">
      <div class="card ">
        <header class="header-card">
          <p>{{ $t('produitPresse.prestationGracieuse.title') }}</p>
        </header>
        <div class="card-content">
          <b-field :label="$t('produitPresse.prestationGracieuse.title')">
            <b-input v-model="sousProduit.prestationGracieuse" type="textarea">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 mgt-20px">
      <div class="card">
        <header class="header-card">
          <p>{{ $t('produitSalon.pj.title')}}</p>
        </header>
        <div class="card-content">
          <pieces-jointes :checkPermissions="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import caracteristique from '@/components/catalogue/produitGeneralPresse/edition/caracteristique';
import schemaComptable from '@/components/general/schemaComptable';
import dates from '@/components/catalogue/produitGeneralPresse/edition/dates';
import piecesJointes from '@/components/general/piecesJointes';
import regleFacturation from '@/components/catalogue/produitGeneralPresse/edition/regleFacturation';
import marche from '@/components/catalogue/produitGeneralPresse/edition/marche';
import selectCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/selectCompteAnalytique';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import messageErreur from '@/services/general/messageErreur';
import formatProduitPresse
  from '@/components/catalogue/produitGeneralPresse/edition/formatProduitPresse';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_produitinformation',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    sousProduit: {
      type: Object,
      required: true,
    },
  },
  components: {
    caracteristique,
    formatProduitPresse,
    schemaComptable,
    dates,
    piecesJointes,
    regleFacturation,
    marche,
    selectCompteAnalytique,
    produitCommentaireVenteCard,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    isProduitTypePresse() {
      return this.produit.produitPresse !== undefined && this.produit.produitPresse !== null;
    },
    produitSociete() {
      return this.societesInformations.find(s => {
        return s.agences.some(a => a.id === this.produit.agenceId);
      })?.id;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    try {
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
